import {
  create_workbook,
  create_worksheet,
  add_worksheet,
  write_workbook,
} from '.';

import RawSequenceData from '../../models/raw-sequence-data';
import Reference from '../../models/reference';
import RawAlignment from '../../models/raw-alignment';
import RawRxHistory from '../../models/raw-rx-history';

export default function downloadWorkbook(rawDataCollection) {

  const wb = create_workbook();
  addReferenceSheet(wb, rawDataCollection.references);
  addSequenceSheet(wb, rawDataCollection.rawSequences);
  addAlignmentSheet(wb, rawDataCollection.rawAlignments);
  addRxHistorySheet(wb, rawDataCollection.rawRxHistory);

  download(wb, rawDataCollection.references);
}

function addReferenceSheet(workbook, references) {
  const reference = references[0];

  const table_headers = [];
  const rows = [];

  for (const header of Object.keys(Reference.propTypes)) {
    table_headers.push(header);
  }

  const row = [];
  for (const key of table_headers) {
    let value = reference[key];
    row.push(JSON.stringify(value));
  }
  rows.push(row);

  const worksheet = create_worksheet(table_headers, rows);
  add_worksheet(workbook, worksheet, 'Reference');
}

function addSequenceSheet(workbook, rawSequences) {
  const rows = [];
  const table_headers = [];
  for (const header of Object.keys(RawSequenceData.propTypes)) {
    table_headers.push(header);
  }
  for (const seq of rawSequences) {
    let row = [];
    for (const key of table_headers) {
      row.push(JSON.stringify(seq[key] || ''));
    }
    rows.push(row);
  }

  const worksheet = create_worksheet(table_headers, rows);
  add_worksheet(workbook, worksheet, 'Sequence');
}

function addAlignmentSheet(workbook, rawAlignments) {
  let rows = [];
  let table_headers = [];
  for (const header of Object.keys(RawAlignment.propTypes)) {
    table_headers.push(header);
  }
  for (const align of rawAlignments) {
    let row = [];
    for (const key of table_headers) {
      row.push(JSON.stringify(align[key] || ''));
    }
    rows.push(row);
  }

  const worksheet = create_worksheet(table_headers, rows);
  add_worksheet(workbook, worksheet, 'Alignment');
}

function addRxHistorySheet(workbook, rawRxHistory) {
  let rows = [];
  let table_headers = [];
  for (const header of Object.keys(RawRxHistory.propTypes)) {
    table_headers.push(header);
  }
  for (const history of rawRxHistory) {
    let row = [];
    for (const key of table_headers) {
      row.push(JSON.stringify(history[key] || ''));
    }
    rows.push(row);
  }
  const worksheet = create_worksheet(table_headers, rows);
  add_worksheet(workbook, worksheet, 'RxHistory');
}

function download(workbook, references) {
  const reference = references[0];
  const filename = `${reference.author}(${reference.refYear}).xlsx`;
  write_workbook(workbook, filename);
}



// WEBPACK FOOTER //
// ./src/components/workbook/download.js